module.exports = __webpack_public_path__ + "media/images/thanksgiving/bg-sm-6f07dbf0d7b10145bd1a6981a199ffb9.jpg";